import { render, staticRenderFns } from "./ModalCaf.vue?vue&type=template&id=721acb08&scoped=true"
import script from "./ModalCaf.vue?vue&type=script&lang=js"
export * from "./ModalCaf.vue?vue&type=script&lang=js"
import style0 from "./ModalCaf.vue?vue&type=style&index=0&id=721acb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721acb08",
  null
  
)

export default component.exports